import { Pipe, PipeTransform } from '@angular/core';
import {TimeZoneService} from '@core/services/time-zone.service';
import {monthNames} from '../constants/dashboard.constants';

@Pipe({
    standalone: false,
    name: 'taxnewsIncorporationTooltipFormat'
})
export class TaxnewsIncorporationTooltipFormatPipe implements PipeTransform {
  constructor(private timeZoneService: TimeZoneService) {
  }

  transform (tooltipString: string, dateObject: any): any {
    const date = this.timeZoneService.getDisplayDate(dateObject);
    let formattedDate = '';
    if (date) {
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();
      formattedDate = day + ' ' + monthNames[monthIndex] + ' ' + year;
    }
    return tooltipString.replace('[DATE]', formattedDate);
  }
}
